<div class="splash-spinner" role="status" aria-live="polite" aria-label="Loading">
    <span class="splash-spinner__ring splash-spinner__ring--outer"></span>
    <span class="splash-spinner__ring splash-spinner__ring--middle"></span>
    <span class="splash-spinner__ring splash-spinner__ring--inner"></span>
    <span class="splash-spinner__core"></span>
</div>
